import { Container, NextLink } from '@/atoms';
import { Button, Content02, Grid } from '@/molecules';
import { GridItem } from '@/molecules/grid/GridItem';
import { CardProductWordpress } from '@/templates';

import { removeBaseURL } from '@/lib/utils';

const ExperienciasFlexibleCategory = ({ bloque, id, className }: any) => (
  <Container
    id={id}
    wrapper
    as="section"
    align="items-center"
    justify="justify-center"
    {...(bloque.backgroundColorString
      ? {
          style: { backgroundColor: bloque.backgroundColorString },
          padding: 'px-4 py-8 md:py-16',
        }
      : {})}
    {...(className && { className })}
  >
    <Content02 pretitle={bloque.pretitulo} title={bloque.titulo}>
      <Grid lg={bloque.itemsPorPagina}>
        {bloque.productos?.filter(Boolean).map((product: any, key: number) =>
          product.products?.edges.map((prod: any) => (
            <GridItem key={`productos-${key}-${prod.node.id}`}>
              <CardProductWordpress
                product={prod.node}
                numColumns={bloque.itemsPorPagina}
              />
            </GridItem>
          )),
        )}
      </Grid>
      {bloque?.contenidoDespuesDeLasExperiencias && (
        <div
          className="u-label u-label--s mb-6 mt-3 flex w-full flex-col items-center justify-center text-center normal-case xs:mt-10 [&>:not(*:last-child)]:mb-2"
          dangerouslySetInnerHTML={{
            __html: bloque.contenidoDespuesDeLasExperiencias,
          }}
        />
      )}

      {bloque?.label && bloque?.link && (
        <NextLink href={removeBaseURL(bloque?.link.url ?? '')} passHref>
          <Button as="a" style={bloque?.style ?? 'primary'} className="mx-auto">
            {bloque.label}
          </Button>
        </NextLink>
      )}
    </Content02>
  </Container>
);

export default ExperienciasFlexibleCategory;

ExperienciasFlexibleCategory.displayName = 'ExperienciasFlexibleCategory';
